var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px" },
          attrs: {
            title: "会员档案详情",
            width: 860,
            visible: _vm.visible,
            footer: null,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            mask: _vm.isDesktop(),
          },
          on: { cancel: _vm.close },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading } },
            [
              _c(
                "a-card",
                {
                  staticStyle: { "margin-bottom": "12px" },
                  attrs: { size: "small", title: "基本信息", bordered: true },
                },
                [
                  _c(
                    "a-descriptions",
                    { attrs: { column: 3, size: "small" } },
                    [
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "会员卡号" } },
                        [_vm._v(_vm._s(_vm.detail.supplierName || "-"))]
                      ),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "当前等级" } },
                        [
                          _vm.detail.levelName
                            ? _c("a-tag", { attrs: { color: "blue" } }, [
                                _vm._v(_vm._s(_vm.detail.levelName)),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ],
                        1
                      ),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "预付款余额" } },
                        [_vm._v(_vm._s(_vm.detail.advanceIn || 0))]
                      ),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "累计零售实付" } },
                        [_vm._v(_vm._s(_vm.detail.consume_total || 0))]
                      ),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "本周期消费" } },
                        [_vm._v(_vm._s(_vm.detail.period_consume || 0))]
                      ),
                      _c("a-descriptions-item", { attrs: { label: "周期" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.period_start
                              ? _vm.detail.period_start +
                                  " ~ " +
                                  (_vm.detail.period_end || "")
                              : "-"
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-card",
                {
                  staticStyle: { "margin-bottom": "12px" },
                  attrs: {
                    size: "small",
                    title: "消费汇总（已审核零售单）",
                    bordered: true,
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "零售合计：" +
                        _vm._s(_vm.detail.retailTotal || 0) +
                        "　　退货合计：" +
                        _vm._s(_vm.detail.returnTotal || 0) +
                        "　　净消费：" +
                        _vm._s(_vm.netConsume)
                    ),
                  ]),
                ]
              ),
              _c(
                "a-card",
                {
                  staticStyle: { "margin-bottom": "12px" },
                  attrs: { size: "small", title: "手动调级", bordered: true },
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "选择目标等级" },
                              model: {
                                value: _vm.targetLevelId,
                                callback: function ($$v) {
                                  _vm.targetLevelId = $$v
                                },
                                expression: "targetLevelId",
                              },
                            },
                            _vm._l(_vm.levels, function (lv) {
                              return _c(
                                "a-select-option",
                                { key: lv.id, attrs: { value: lv.id } },
                                [_vm._v(_vm._s(lv.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "调级原因（选填，记入日志）",
                            },
                            model: {
                              value: _vm.levelReason,
                              callback: function ($$v) {
                                _vm.levelReason = $$v
                              },
                              expression: "levelReason",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: !_vm.targetLevelId,
                              },
                              on: { click: _vm.handleLevelChange },
                            },
                            [_vm._v("调级")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-card",
                {
                  staticStyle: { "margin-bottom": "12px" },
                  attrs: {
                    size: "small",
                    title: "会员卡（收银台扫码识别会员）",
                    bordered: true,
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "text-align": "center" } },
                    [
                      _vm.cardBase64
                        ? _c("img", {
                            staticStyle: { width: "220px", height: "220px" },
                            attrs: {
                              src: "data:image/png;base64," + _vm.cardBase64,
                              alt: "会员卡二维码",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-left": "16px" },
                          on: { click: _vm.loadCard },
                        },
                        [_vm._v("显示会员卡")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-card",
                {
                  attrs: {
                    size: "small",
                    title: "近期零售单（最近 20 笔）",
                    bordered: true,
                  },
                },
                [
                  _c("a-table", {
                    attrs: {
                      size: "small",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.orderColumns,
                      dataSource: _vm.detail.recentOrders || [],
                      pagination: false,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }